import * as countries from "@/constants/countries"
const PhoneNumber = require('awesome-phonenumber');

export default {
  name: "reset-modal",
  props: ["auth"],
  components: {},
  data() {
    return {
      STAGES: ["CONFIRM_PHONE, RESET"],
      stage: null,
      phone: "",
      selectedCountry: null,
      fullPhone: "",
      selectedCountryCode: countries.data.find(country => country.name.toLowerCase() === "nigeria").dial_code,
      countries: countries.data,
      phoneValid: false,
      passcode: "",
      newPassword: "",
      passwordShown: false
    };
  },
  created() {
    this.stage = this.STAGES[0];
  },
  computed: {
    resetValid: function() {
      return  this.passcode.length === 7 && this.newPassword.length >= 6;
    }
  },
  methods: {
    getPasscode(e) {
      if (!this.phoneValid) {
        return
      }
      const btn = e.submitter;
      const btnText = btn.innerText;

      btn.innerText = 'Processing';
      btn.disabled = true;
      btn.classList.add('btn--loading');

      function enableBtn() { 
        btn.innerText = btnText;
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      }

      this.$props.auth.beginReset(this.fullPhone).then(() => {
        enableBtn();
        this.stage = this.STAGES[1];
      }).catch(err => {
        enableBtn();
        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      });
    },
    resetPassword(e) {
      if (!this.resetValid) {
        return
      }
      const btn = e.submitter;
      const btnText = btn.innerText;

      btn.innerText = 'Processing';
      btn.disabled = true;
      btn.classList.add('btn--loading');

      function enableBtn() { 
        btn.innerText = btnText;
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      }

      this.$props.auth.completeReset(this.passcode, this.newPassword).then(() => {
        enableBtn();
        this.$notification.new("Your password has been reset. You can continue to log in to your Infodemics account.");
        document.getElementById('toLoginBtn').click();
      }).catch(err => {
        enableBtn();
        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      });
    },
    togglePassword() {
      this.passwordShown = !this.passwordShown;
      document.getElementById('resetPassword').type = document.getElementById('resetPassword').type === 'password' ? 'text' : 'password'; 
    },
    resetForm() {
      this.stage = this.STAGES[0];
      this.phone = "";
      this.fullPhone = "";
      this.phoneValid = false;
      this.passcode = "";
      this.newPassword = "";
      this.passwordShown = false;
    }
  },
  watch: {
    "selectedCountryCode": {
      handler: function(val) {
        this.selectedCountry = this.countries.find(country => country.dial_code === val);
        const phone = new PhoneNumber(this.phone, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      },
      immediate: true,
      deep: true
    },
    "phone": {
      handler: function(val) {
        const phone = new PhoneNumber(val, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        } else {
          this.phoneValid = phone.false;
        }
      }
    }
  }
};
